import script from "./reminder.vue?vue&type=script&setup=true&lang=js"
export * from "./reminder.vue?vue&type=script&setup=true&lang=js"

import "./reminder.vue?vue&type=style&index=0&id=f9cf0816&scoped=true&lang=stylus"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9cf0816"]])

export default __exports__